export default __webpack_public_path__ + "static/advanced_v1-d1d178f9cf508656f284d04afdac9a19.webp";